export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00019.8587aba2.png";